export default __webpack_public_path__ + "static/media/0x1b815d120b3ef02039ee11dc2d33de7aa4a8c603.97f6b3e7.svg";